import { useRef, useLayoutEffect, useState } from 'react';

// given a child text element, measure the exact
// width of characters/spaces in the current font
export function useTextWidth({
  text,
  minText = '',
  selector: childSelector = 'input'
}) {
  const parentRef = useRef(null);
  const [fontString, setFontString] = useState('0px')
  const [width, setWidth] = useState(0)

  // Read the font props from the element
  useLayoutEffect(() => {
    if (parentRef.current) {
      const input = parentRef.current.querySelector(childSelector)
      if (input) {
        const computed = window.getComputedStyle(input)
        const font = [
          computed.fontStyle,
          computed.fontVariant,
          computed.fontWeight,
          computed.fontSize,
          computed.lineHeight !== 'normal' ? `/${computed.lineHeight}` : '',
          computed.fontFamily
        ].filter(Boolean).join(' ')
        setFontString(font)
      }
    }
  }, [childSelector])

  // Update text width on every change
  useLayoutEffect(() => {
    if (fontString) {
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      context.font = fontString
      const { width: textWidth } = context.measureText(text || minText)
      setWidth(`${textWidth}px`)
    }
  }, [text, fontString])

  return { width, parentRef }
}
